module.exports = __webpack_public_path__ + "static/media/30.bb526872.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/30.jpg
// module id = 591
// module chunks = 0